// @flow

import * as React from "react"

type AProps = {|
    href: string,
    style?: { [string]: string | number },
    outbound?: boolean,
    className?: string,
    children: React.Node,
|}

export function A({ href, outbound = false, children, ...rest }: AProps) {
    const extra = {}
    const crossOrigin = Boolean(href.match(/https?:\/\//))

    if (outbound) extra.target = "_blank"
    if (crossOrigin) extra.rel = "noopener"

    return (
        <a {...rest} {...extra} href={href}>
            {children}
        </a>
    )
}
